import React from "react";
import PageHeading from "../../components/PageHeading";
import DCard from "../../components/DCard";
import FormikContainer from "../../components/Formik/FormikContainer";
import DButton from "../../components/DButton";
import { Form } from "formik";
import { Spinner } from "@chakra-ui/react";
import FieldContainer from "../../components/Formik/FieldContainer";
import orderServices from "../../services/orders";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";

const initialValues = {
  note: "",
};
const AddNote = ({ title }) => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const onSubmit = (values, { setSubmitting }) => {
    orderServices
      .updateOrderNote(orderId, values)
      .then(() => {
        toast.success("تم التعديل بنجاح");
        setTimeout(() => {
          navigate("/orders");
        }, 1500);
      })
      .catch(() => toast.error("فشلت عملية التعديل"));
    setTimeout(() => {
      setSubmitting(false);
    }, 1500);
  };

  if (isNaN(Number(orderId)) || !orderId) {
    return <Navigate to="/404" />;
  }
  return (
    <div>
      <PageHeading>{title}</PageHeading>
      <DCard>
        <FormikContainer initialValues={initialValues} onSubmit={onSubmit}>
          {({ isSubmitting }) => {
            return (
              <Form>
                <FieldContainer
                  id="note"
                  name="note"
                  type={"textarea"}
                  label={"ملاحظة"}
                />
                <DButton
                  disabled={isSubmitting}
                  type="submit"
                  className="mx-auto min-w-[150px] flex items-center justify-center text-white"
                >
                  {isSubmitting ? <Spinner /> : "تعديل"}
                </DButton>
              </Form>
            );
          }}
        </FormikContainer>
      </DCard>
    </div>
  );
};

export default AddNote;
